require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-10-essentials-to-get-your-store-ready-for-christmas.json") })
        }
      }, "path---blog-10-essentials-to-get-your-store-ready-for-christmas");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-10-essentials-to-get-your-store-ready-for-christmas!./.cache/json/blog-10-essentials-to-get-your-store-ready-for-christmas.json
// module id = 376
// module chunks = 231608221292675